import { useState } from 'react';
import * as api from '../lib/api';
import { haptic } from '../lib/telegram';
import { useT } from '../lib/i18n';

/**
 * Asking a client whether their coach may write down an injury.
 *
 * Shown to anyone already on the books who has not been asked — people
 * who joined before there was a question. Someone brand new is asked by
 * the bot instead, on their first Start.
 *
 * Both answers are one tap and equally easy to reach. A "no" that takes
 * more work than a "yes" is not really a choice, and this is the kind of
 * consent that has to be freely given to count for anything.
 */

export function HealthConsentCard({ onAnswered }: { onAnswered: () => void }) {
  const t = useT();
  const [busy, setBusy] = useState(false);

  async function answer(consent: boolean) {
    setBusy(true);
    try {
      await api.answerHealthConsent(consent);
      haptic.success();
      onAnswered();
    } catch {
      // Left unanswered, so it is asked again next time rather than
      // recorded as something they did not say.
      haptic.error();
      setBusy(false);
    }
  }

  return (
    <div className="card" style={{ margin: '12px 16px' }}>
      <div style={{ lineHeight: 1.45 }}>{t('health.ask')}</div>
      <div className="sheet__actions">
        <button className="paybar__opt" disabled={busy} onClick={() => answer(false)}>
          {t('health.no')}
        </button>
        <button className="savebtn" disabled={busy} onClick={() => answer(true)}>
          {t('health.yes')}
        </button>
      </div>
    </div>
  );
}
